import { PERSISTED_CACHE_STORAGE_KEY, removePersistedQueryCache } from './persister';

/** Drop in-memory React Query state and persisted cache for the given user scope. */
export function clearAllQueryCache(queryClient, userId = null) {
  if (!queryClient) return;
  queryClient.clear();
  removePersistedQueryCache(userId);
}

/**
 * Remove legacy persisted keys from older deploy busters / non-user-scoped keys.
 *
 * Keeps this build's user-scoped keys (prii-query-cache-<buster>-<userId|anon>): this runs on every boot, and it used
 * to delete those too - on the web build that is the whole persisted cache (on native, the localStorage mirror).
 */
export function removeLegacyPersistedQueryCaches() {
  if (typeof window === 'undefined') return;
  try {
    const prefix = 'prii-query-cache-';
    const currentScopedPrefix = `${PERSISTED_CACHE_STORAGE_KEY}-`;
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key?.startsWith(prefix) && !key.startsWith(currentScopedPrefix)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => {
      try {
        localStorage.removeItem(key);
      } catch {
        /* ignore */
      }
    });
  } catch (err) {
    console.warn('[query] failed to remove legacy persisted caches:', err);
  }
}
